import React from 'react'
import {
  Box,
  makeStyles,
  Button,
  Typography,
  Container,
} from '@material-ui/core'
import { get, capitalize } from 'lodash'
import HandicapIconsList from '../../molecules/HandicapIconsList'
import { REFERENTIAL_VIEW } from './constants'
import useReferer from '../../../hooks/useReferer'

const useStyles = makeStyles((theme) => ({
  root: { display: 'flex' },
  picto: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    marginRight: theme.spacing(4),

    [theme.breakpoints.down('xs')]: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      marginRight: theme.spacing(2),
    },
    objectFit: 'contain',
    boxShadow: theme.shadows[1],
  },
  container: { width: '100%' },
  subtitle: {
    marginBottom: theme.spacing(4),
  },
  topContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '1vw',
    marginBottom: theme.spacing(2),
  },

  address: {},
  button: {
    marginTop: theme.spacing(4),
  },
}))

const buttonClick = (setView, referer) => {
  setView(REFERENTIAL_VIEW)
  if (window.parent) {
    window.parent.postMessage(
      { event_type: 'picto-widget-modal-change-view', view: REFERENTIAL_VIEW },
      referer,
    )
  }
}

const ShowReferentialButton = ({ setView }) => {
  const classes = useStyles()
  const referer = useReferer()

  return (
    <Button
      className={classes.button}
      onClick={() => buttonClick(setView, referer)}
      variant="contained"
      color="primary"
    >
      Voir l'accessibilité du lieu
    </Button>
  )
}

const Root = ({ card, setView }) => {
  const classes = useStyles()
  const title = get(card, 'content.title', '')
  const picto = get(card, 'picto', null)
  const address = `${get(card, 'localisation.address', '')} ${get(
    card,
    'localisation.city.postal_code',
    '',
  )} ${capitalize(get(card, 'localisation.city.name', ''))}`
  const handicaps = get(card, ['accessibility_description', 'handicaps'], {})

  return (
    <Container className={classes.root} maxWidth="md">
      <Box className={classes.container}>
        <Box className={classes.topContainer}>
          {picto && (
            <img
              className={classes.picto}
              src={picto.medium_url}
              alt={picto.caption}
            />
          )}
          <Box>
            <Typography variant="h4">{title}</Typography>
            <Typography
              gutterBottom={false}
              className={classes.address}
              variant="h5"
            >
              {address}
            </Typography>
          </Box>
        </Box>
        <HandicapIconsList handicaps={handicaps} />
        <ShowReferentialButton setView={setView} />
      </Box>
    </Container>
  )
}

export default Root
